import React from 'react';
import { Type, TypeSpec } from 'src/models/Sidekick/SidekickModuleSpec';
import InputField, { InputType } from 'src/presentation/components/forms/InputField';

const InputControl = ({
  'data-aid': dataAid,
  attr,
  description,
  disabled,
  placeholder,
  type,
  typeSpec,
}: {
  'data-aid'?: string;
  attr: string;
  description?: string;
  disabled: boolean;
  placeholder?: string;
  type?: InputType;
  typeSpec: TypeSpec;
}) => {
  const inputType =
    typeSpec.type === Type.currency || typeSpec.type === Type.number ? InputType.number : InputType.text;

  return (
    <InputField
      attr={attr}
      data-aid={dataAid}
      placeholder={placeholder}
      description={description}
      disabled={disabled}
      label={typeSpec.prompt}
      type={type || inputType}
    />
  );
};

export default InputControl;
